import { AccountType } from '@/context/types/Account';
import { Feature } from '@/config/featureFlags.definition';
import { IconProps } from '@/components/Icons/types/IconInterface';
import { TIconColor } from '@/components/Icons/iconVariant';
import type { SideNavSubMenuItem } from '@/versions/v3/features/home/components/NavigationBar/SideNavSubMenu';
import { EnumValues } from '@/services/types/EnumValues';

export const NavItemIdEnum = {
  HOME: 'home',
  ACCOUNTS: 'accounts',
  MANAGE: 'manage',
  SETTINGS: 'settings',
  GL_SETTINGS: 'gl-settings',
  XERO: 'xero',
  PAYMENTS: 'payments',
  TEAM_MEMBERS: 'team-members',
  HELP: 'help',
  FIND_ANSWERS: 'find-answers',
  TALK_TEAMS: 'talk-teams'
} as const;

export type TNavItemId = EnumValues<typeof NavItemIdEnum>;

export type TActionKey = 'xero-modal';

export type TNavSubItemConfig = {
  id: string;
  label: string;
  route?: string;
  actionKey?: TActionKey;
  requiredAccountType?: AccountType;
  requiredFeature?: Feature;
};

export type TNavItemConfig = {
  id: string;
  label: string;
  icon: React.ComponentType<IconProps & { color?: TIconColor }>;
  route?: string;
  actionKey?: TActionKey;
  requiredAccountType?: AccountType;
  requiredFeature?: Feature;
  subItems?: TNavSubItemConfig[];
};

export type TNavSectionConfig = {
  id: string;
  label: string;
  items: TNavItemConfig[];
};

export type TResolvedNavItem = {
  id: string;
  label: string;
  icon: React.ComponentType<IconProps & { color?: TIconColor }>;
  route?: string;
  onClick?: () => void;
  subItems?: SideNavSubMenuItem[];
};

export type TResolvedNavSection = {
  id: string;
  label: string;
  items: TResolvedNavItem[];
};
